import { Component, OnInit, Input } from '@angular/core';
import { LawNavItem } from '../../models/models';

@Component({
    selector: 'nav-item',
    templateUrl: './nav-item.component.html',
    styleUrls: ['./nav-item.component.scss'],
    standalone: false
})
export class NavItemComponent implements OnInit {
    @Input()
    public item: LawNavItem;

    constructor() {}

    ngOnInit() {
        
    }    
}
